import { render, staticRenderFns } from "./valentine.vue?vue&type=template&id=05b5a132&scoped=true"
import script from "./valentine.vue?vue&type=script&lang=js"
export * from "./valentine.vue?vue&type=script&lang=js"
import style0 from "./valentine.vue?vue&type=style&index=0&id=05b5a132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5a132",
  null
  
)

export default component.exports